import {AbstractControl, FormGroup, ValidatorFn} from '@angular/forms';

import {EmployeeView} from 'planner-shared';

export namespace TimeValidators {
    export const timeGreaterThan = (time: string): ValidatorFn => {
        return (control: AbstractControl): { [key: string]: any } => {
            const value = control.value;

            if (value > time) {
                return {
                    timeGreater: 'timeGreater'
                };
            }

            return {};
        };
    };

    export const timeLessThan = (time: string): ValidatorFn => {
        return (control: AbstractControl): { [key: string]: any } => {
            const value = control.value;

            if (value < time) {
                return {
                    timeLess: 'timeLess'
                };
            }

            return {};
        };
    };


    export const dateAndTimeGreaterThanOrEqual = (
        fromDateValue: string,
        fromTime: string,
        toDateValue: string,
        toTime: string
    ): ValidatorFn => {
        return (group: FormGroup): { [key: string]: any } => {
            const fromTimeValue = group.controls[fromTime].value;
            const toTimeValue = group.controls[toTime].value;

            if (fromDateValue > toDateValue || (fromDateValue === toDateValue && fromTimeValue >= toTimeValue)) {
                return {
                    dateAndTimeGreaterThanOrEqual: 'dateAndTimeGreaterThanOrEqual'
                };
            }

            return {};
        };
    };

    export const timeOverlaps = (
        employees: EmployeeView[],
        employee: EmployeeView,
        fromTimeInputName: string,
        toTimeInputName: string
    ): ValidatorFn => {
        return (group: FormGroup): { [key: string]: any } => {
            for (let i = 0; i < employees.length; i++) {
                const employee1: EmployeeView = employees[i];
                if (employee1 === employee) {
                    continue;
                }
                const fromTimeValue = group.controls[fromTimeInputName].value;
                const toTimeValue = group.controls[toTimeInputName].value;
                if (employee1.fromTime > fromTimeValue && employee1.fromTime < toTimeValue
                    || employee1.toTime > fromTimeValue && employee1.toTime < toTimeValue
                    || employee1.fromTime <= fromTimeValue && employee1.toTime > fromTimeValue
                ) {
                    return {
                        timeOverlaps: 'timeOverlaps'
                    };
                }
            }
            return {};
        };
    };

    export const timeExceedsWindow = (
        employeeView: EmployeeView
    ):
        ValidatorFn => {
        return (group: FormGroup): { [key: string]: any } => {
            let fromTimeFormValue = group.controls['fromTime'].value;
            let toTimeFormValue = group.controls['toTime'].value;
            const employeeFromTime = new Date(employeeView.fromDate + "T" + employeeView.fromTime);
            const employeeToTime = new Date(employeeView.toDate + "T" + employeeView.toTime);

            const formFromTime = new Date(employeeView.fromDate + "T" + fromTimeFormValue);
            const formToTime = new Date(employeeView.fromDate + "T" + toTimeFormValue);

            if (formFromTime > formToTime) {
                formToTime.setDate(formToTime.getDate() + 1);
            }

            if (formFromTime < employeeFromTime || formFromTime > employeeToTime ||
                formToTime < employeeFromTime || formToTime > employeeToTime) {
                return {
                    windowExceeds: 'windowExceeds'
                };
            }
            return {};
        };
    };
}
